import { observable } from "mobx";
import { api, api_adm } from "../../api";
import { toast } from "react-toastify";

class _EmpresaAdminStore {

  obs = observable({
    empresas: [],
    empresas_length: 0
  })

  async handleLoadEmpresas(page: number, empresa: any, conta: any) {

    try {

      let params = {
        page: page,
        limit: 20,
        empresa: empresa,
        conta: conta
      }

      let resp = await api_adm.post("/api/admin/empresas/index", params);

      this.obs.empresas = [];
      this.obs.empresas_length = 0

      if (resp.data.itens.length > 0) {

        this.obs.empresas_length = resp.data.count
        this.obs.empresas = resp.data.itens

      }

    } catch (ex) {

      toast.error('Erro ao carregar Empresas, tente novamente mais tarde.', {});

    }

  }

  async downloadEmpresaPfx(cnpj: string, conta_id: string, senha: string, tipo: string) {

    try {

      let data = { cnpj: cnpj, conta_id: conta_id, tipo: tipo, senha: senha }

      let resp = await api_adm.post("/api/admin/empresas/download", data)

      if (resp.data.ok) {

        const linkSource = `data:application/pfx;base64,${resp.data.base64}`;
        const downloadLink = document.createElement("a");
        let fileName = tipo == "conta" ? `${conta_id}.pfx` : `${cnpj}.pfx`;

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();

      } else {

        toast.error(resp.data.msg, {});

      }

    } catch (ex) {

      toast.error('Erro ao realizar o download, tente novamente mais tarde', {});

      return false

    }

  }

}

export const EmpresaAdminStore = new _EmpresaAdminStore();
